Fancybox.bind("[data-fancybox]", {
    // https://fancyapps.com/fancybox/plugins/thumbs/
    Thumbs: {
        showOnStart: false,
        type: "classic",
    },
});